
import { ToolbarService } from "@/services/toolbar-service";
import { UserConfigService } from "@/services/user-config-service";
import { loadLanguageAsync } from "@/setup/i18n-setup";
import AppNavItem from "@/components/common/DefaultRouteNavItem.vue";
import AppDemoShedule from "@/components/account/DemoShedule.vue";
import Vue from "vue";
import { Permissions } from "../models/user-configs/permissions";
import { MODULE } from "@/config/modules";
import { AuthService } from "../services/auth-service";
import { Browse } from "../models/browse";
import AppRenewInfo from "@/components/common/RenewInfo.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { Tier } from "@/utils/payments/tiers";
import { DrawerLink } from "@/utils/drawer-links/drawer-link";
import { DrawerLinkWrapper } from "@/utils/drawer-links/drawer-link-wrapper";
import { getFixedDrawerLinksForGroup } from "@/utils/drawer-links/fixed-drawer-links";
import { tokenStore } from "@/utils/token-store";
import { HomeVisibleLinks } from "@/models/user-configs/visible-links-home";

export default Vue.extend({
	data() {
		return {
			toggleDrawer: false,
			toggleDemoShedule: false,
			renewShow: false,
			forceCloseSaleBar: false,
			ToolbarService,
			UserConfigService,
			dossierConfig: AuthService.wfDossier
		};
	},
	computed: {
		visibleLinks():HomeVisibleLinks {
			return UserConfigService.getVisibleLinks().Home;
		},
		drawer: {
			get(): boolean | number {
				return this.ToolbarService.drawer;
			},
			set(value: boolean | number) {
				this.ToolbarService.drawer = value;
			}
		},
		disabledDrawer(): boolean {
			return AuthService.wfCompany.isExpired();
		},
		permissions(): Permissions {
			return this.UserConfigService.getPermissionSettings();
		},
		isDemo(): Boolean {
			return AuthService.wfCompany.IsDemo;
		},
		daysTillActivationNum():number {
			if (AuthService.wfCompany) {
				var d1 = AuthService.wfCompany.ActiveUntil;
				var diff = d1.getTime() - new Date().getTime();
				return (diff / (1000 * 3600 * 24));
			}
			return 0;
		},
		daysTillActivation(): string {
			if (AuthService.wfCompany) {
				return this.daysTillActivationNum.toFixed(0);
			}
			return "";
		},
		dayBeforeMsg(): string {
			if (this.daysTillActivation == "0") {
				return this.$ct("demo-expire-last", {days: this.daysTillActivation}).toString();
			}
			return this.$ct("demo-expire", {days: this.daysTillActivation}).toString();

		},
		showServicePackExpiredMessages():boolean {
			if (this.forceCloseSaleBar) return false;
			if (this.isDemo) return false;
			if (AuthService.wfCompany.ServicePackExpirationDate == null) return false;
			if (this.$route.path != "/home") return false;
			if (AuthService.wfCompany.ServicePackExpirationDate < new Date()) {
				return true;
			}
			return false;
		},
		showDemoExpiresMessage():boolean {
			if (!this.isDemo) return false;
			if (this.daysTillActivationNum<0) return false;
			return true;
		},
		showQuickStart():boolean{
			return DossierConfigService.getGeneralConfig().ShowQuickStart;
		},
		showSettings():boolean{
			return AuthService.isDevModeEnabled;
		},
		showSettingsLink():boolean{
			if (AuthService.wfCompany && AuthService.wfUser && AuthService.wfUser.ID == AuthService.wfCompany.OwnerID) return true;
			return this.visibleLinks.Settings;
		},
		showInbox():boolean{
			return AuthService.isDevModeEnabled || AuthService.wfCompany.Tier != Tier.FREE;
		},
		notifyClass():boolean {
			return (this.renewShow || this.showServicePackExpiredMessages || this.showDemoExpiresMessage) && AuthService.wfCompany.Tier != Tier.FREE;
		},
		hasProjectModule():boolean{
			return AuthService.hasModule(MODULE.PROJECTEN_BEHEER);
		},
		hasPriceListModule():boolean{
			return AuthService.hasModule(MODULE.EXTERNE_PRODUCT_CATALOGUS);
		},
		isAccountant():boolean{
			return tokenStore.isAccountant;
		},
		drawerLinks(): DrawerLinkWrapper {
			return this.UserConfigService.getDrawerLinkSettings();
		},
		visibleDrawerLinks(): Record<string, DrawerLink[]> {
			const all = this.drawerLinks;
			const isDev = this.showSettings;
			const filter = (links: DrawerLink[]) => links.filter(l => !l.DevOnly || isDev);
			return {
				Top: filter([...all.Top, ...getFixedDrawerLinksForGroup("Top")]),
				Contacts: filter(all.Contacts),
				Products: filter(all.Products),
				Sales: filter(all.Sales),
				Buy: filter(all.Buy),
				Financial: filter(all.Financial),
				Tools: filter(all.Tools),
				Bottom: filter(all.Bottom),
			};
		}
	},
	watch: {
		"$route.path"() {
			if (this.$wf.isSmDown) {
				this.ToolbarService.drawer = false;
			}
		},
		"$wf.isSmDown"() {
			this.drawer = !this.$wf.isSmDown;
		}
	},
	methods: {
		async changeLanguage(value: string) {
			loadLanguageAsync(value);
			let settings = UserConfigService.getGeneralSettings();
			settings.SelectedLang = value;
			await UserConfigService.setGeneralSettings(settings);
		},
		getBrowseIcon(browseId: number) {
			return Browse.getIconClassByBrowseId(browseId);
		}
	},
	mounted() {
		this.drawer = !this.$wf.isSmDown;
	},
	components: {
		AppNavItem,
		AppDemoShedule,
		AppRenewInfo

	},
	i18nEx: {
		componentPrefix: "views.DefaultRoute"
	}
});
